import React from "react";
import { Helmet } from "react-helmet";
import { Route, Switch, withRouter } from "react-router";
import { ModuleContext } from "../components/authProvider/main";
import { ParametersGlobals } from "../core/parametersGlobals/ParametersGlobals";
import { Page404 } from "./404";
import DashboardPage from "./DashboardPage";
import BrowsePage from "./crud/BrowsePage";
import EditPage from "./crud/EditPage";
import ReadPage from "./crud/ReadPage";
import ImportPage from "./imports/importPage";
import ViewProfilePage from "./profile/ViewProfilePage";
import RelationPage from "./relations/relationPage";
import { ReportPage } from "../components/reports/ReportPage";

class DefaultDashboardPage extends React.Component<any> {
  static contextType = ModuleContext;
  public state = {
    isLoading: false,
    usuario: null,
  };

  getModulesLocal = ({ moduleName }: { moduleName: string }) => {
    const modulesLocal: any = localStorage.getItem("modules");
    const modulesLocalJson = JSON.parse(modulesLocal);
    let objectReturn: any = undefined;
    for (const item of modulesLocalJson) {
      if (item.module_url === moduleName) {
        objectReturn = item;
        break;
      }
    }
    return objectReturn;
  };

  componentDidUpdate(props: any) {
    const { module } = this.props.match.params;
    const moduleConfig = this.getModulesLocal({
      moduleName: module,
    });
    if (!moduleConfig.module_url === module) {
      this.props.history.push("/dashboard");
    }
    if ((this.context as any).name !== module) {
      var color = null;
      if (moduleConfig.module_url === module) {
        color = moduleConfig.module_color;
      }
      (this.context as any).setModule(module, color);
      this.setState({ isLoading: false });
    }
  }

  componentDidMount = () => {
    const { module }: any = this.props.match.params;
    const moduleConfig = this.getModulesLocal({
      moduleName: module,
    });
    if (!moduleConfig.module_url === module) {
      this.props.history.push("/dashboard");
    }
    if (
      ((this.context as any).name !== module || (this.context as any).color === null) &&
      moduleConfig.module_color
    ) {
      var color = null;
      if (moduleConfig.module_url === module) {
        color = moduleConfig.module_color;
      }
      (this.context as any).setModule(module, color);
    }
  };

  render() {
    const { path } = this.props.match;
    const { module } = this.props.match.params;
    const moduleConfig = this.getModulesLocal({
      moduleName: module,
    });
    if (!moduleConfig) {
      this.props.history.replace("/dashboard/configuracoes/404");
      return null;
    }
    if (this.state.isLoading === true) {
      return null;
    }

    return (
      <div className={module + "-page"}>
        <Helmet>
          <title>
            {`${ParametersGlobals.projectTitle}`} {moduleConfig.module_full_name ?? moduleConfig.module_label}
          </title>
        </Helmet>
        <Switch>
          {this.props.location.pathname.includes("/import") ? (<Route exact path={path} component={ImportPage} />) : (<Route exact path={path} component={DashboardPage} />)}
          
          {this.props.location.pathname.includes("/depara") ? (<Route exact path={path + '/depara'} component={RelationPage} />) : null}

          <Route exact path={path + "/reports"} component={ReportPage} />

          <Route exact path={path + "/profile"} component={ViewProfilePage} />

          <Route exact path={path + "/404"} component={Page404} />

          <Route exact path={path + "/:crud"} component={BrowsePage} />

          <Route exact path={path + "/:crud/add"} component={EditPage} />

          <Route exact path={path + "/:crud/:id"} component={EditPage} />

          <Route exact path={path + "/:crud/view/:id"} component={ReadPage} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(DefaultDashboardPage);
